import { useEffect, type ReactNode } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'phosphor-react';

export function Sheet({ open, onClose, title, children }: { open: boolean; onClose: () => void; title?: string; children: ReactNode }) {
  useEffect(() => {
    function onKey(e: KeyboardEvent) { if (e.key === 'Escape') onClose(); }
    if (open) document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div className="fixed inset-0 bg-ink-1/40 z-40" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={onClose} />
          <motion.div className="fixed left-0 right-0 bottom-0 z-50 bg-paper-elev rounded-t-xl ring-1 ring-paper-edge shadow-sheet"
            initial={{ y: '100%' }} animate={{ y: 0 }} exit={{ y: '100%' }} transition={{ type: 'spring', stiffness: 200, damping: 24 }}>
            <div className="pt-3 pb-1 flex justify-center"><span className="block w-10 h-1 rounded-full bg-champagne/70" /></div>
            <div className="flex items-center justify-between px-6 pt-2">
              {title ? <h3 className="t-ed-lg">{title}</h3> : null}
              <button onClick={onClose} className="ml-auto h-9 w-9 grid place-items-center rounded-full hover:bg-paper-rec"><X size={18} /></button>
            </div>
            <div className="px-6 pb-[max(env(safe-area-inset-bottom),16px)] pt-3 max-h-[80vh] overflow-y-auto scrollbar-none">{children}</div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
